import { ExpandMore } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import React, { SyntheticEvent, useState } from "react";
import { TimeSlider } from "./time-slider";
import { DatePicker } from "./date-time-picker";
import { DateTime } from "luxon";

export interface ITimeRangeSelectionProps {
  onchange?: (value: DateTime) => void;
  onError: (message?: string) => void;
}
type TimeRangeOption = "quick" | "advanced";

export function TimeRangeSelection(props: ITimeRangeSelectionProps) {
  const [expanded, setExpanded] = useState<TimeRangeOption | undefined>(
    undefined,
  );

  const [time, setTime] = useState<DateTime>(DateTime.now());

  const handleTimeChange = (value: DateTime) => {
    setTime(value);
    props.onchange(value);
  };

  const handleChange =
    (panel: TimeRangeOption) =>
    (event: SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : undefined);
    };

  return (
    <>
      <Accordion
        expanded={expanded === "quick"}
        onChange={handleChange("quick")}
      >
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls="quick-content"
          id="quick-header"
        >
          <Typography sx={{ width: "33%", flexShrink: 0, fontWeight: "bold" }}>
            Quick Recovery
          </Typography>
          <Typography sx={{ color: "text.secondary" }}>
            Set a restore point within the last four hours
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <TimeSlider value={time} onChange={handleTimeChange} />
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "advanced"}
        onChange={handleChange("advanced")}
      >
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls="advanced-content"
          id="advanced-header"
        >
          <Typography sx={{ width: "33%", flexShrink: 0, fontWeight: "bold" }}>
            Advanced Recovery
          </Typography>
          <Typography sx={{ color: "text.secondary" }}>
            Set a restore point at a specific date and time
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <DatePicker
            onChange={handleTimeChange}
            value={time}
            onError={props.onError}
          />
        </AccordionDetails>
      </Accordion>
    </>
  );
}
